import secondaryComponents from "../..";
import { usePlatformCreditTable } from "./usePlatformCreditTable";

export const PlatformCreditTable = ({
  creditTransactions,
  metaDetails,
  gotoPage = () => {},
}) => {
  const { instance } = usePlatformCreditTable({
    creditTransactions,
  });
  const { getTableBodyProps, getTableProps, headerGroups, rows, prepareRow } =
    instance;

  return (
    <>
      <secondaryComponents.TableHelper
        getTableBodyProps={getTableBodyProps}
        getTableProps={getTableProps}
        headerGroups={headerGroups}
        rows={rows}
        prepareRow={prepareRow}
        // hasAction={true}
      >
        <div className="pt-5 text-center">
          <h4>No Data Available</h4>
        </div>
      </secondaryComponents.TableHelper>

      {/* pagination */}
      {creditTransactions?.length > 0 && (
        <div className="mt-auto">
          <secondaryComponents.Pagination
            totalPageNumber={metaDetails?.last_page}
            handlePageClick={(value) => gotoPage(value?.selected + 1)}
            currentPage={metaDetails?.current_page}
          />
        </div>
      )}
    </>
  );
};
